module.exports = __webpack_public_path__ + "b7ed6dbf58f1f4f85b6a038bef31864c.pdf";